/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Table_Tax_IdInputs */

const en_clients_table_tax_id = /** @type {(inputs: Clients_Table_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID`)
};

const pt_br2_clients_table_tax_id = /** @type {(inputs: Clients_Table_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF/CNPJ`)
};

/**
* | output |
* | --- |
* | "Tax ID" |
*
* @param {Clients_Table_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_tax_id = /** @type {((inputs?: Clients_Table_Tax_IdInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_Tax_IdInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_tax_id(inputs)
	return pt_br2_clients_table_tax_id(inputs)
});